/*
  Copyright Epic Games, Inc. All Rights Reserved.
*/

import { CosmosImageType, useCosmosComponentContext } from "@components/context";

export const CosmosImage = (props: CosmosImageType): React.JSX.Element | null => {
	const { Image } = useCosmosComponentContext();

	if (!props.src) {
		return null;
	}

	return <Image {...props} />;
};
